<template>
  <base-dialog :visible.sync="visible" class="edit-workflow-info-dialog">
    <template #header>编辑基本信息</template>
    <div class="row">
      <div class="title">名称</div>
      <el-input ref="nameInput" v-model="form.name"></el-input>
    </div>
    <div class="row">
      <div class="title">说明</div>
      <el-input type="textarea" rows="3" resize="none" v-model="form.desc"></el-input>
    </div>
    <div class="row" v-if="form.triggerType !== 'START_TYPE_SUB'">
      <div class="title">异常通知</div>
      <user-scope-selector
        v-model="form.userToNotify"
        :users="curUsers"
        tip="选择人员范围"
        :root-department="rootDepartment"
        v-bind="$attrs"
        style="margin-top: 10px"
        :show-department-tab="false"
        :additional-tabs="additionalTabs"
        clearable
        multiple
      ></user-scope-selector>
    </div>
    <template #footer>
      <base-button @click="visible = false">取 消</base-button>
      <base-button type="primary" @click="submit">确 定</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { getCompanyUsers, getDepartmentTree } from "@/api/userCenter/company"
import { getRoles } from "@/api/appManage/role"
export default {
  name: "edit-workflow-info-dialog",
  components: { UserScopeSelector, BaseButton, BaseDialog },
  data() {
    return {
      visible: false,
      form: {},
      curUsers: [],
      rootDepartment: {},
      appRoles: []
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    },
    additionalTabs() {
      return [
        {
          label: "应用角色",
          value: "role",
          options: this.appRoles
        },
        {
          label: "工作流",
          value: "var",
          options: [
            {
              id: "trigger",
              name: "流程触发人"
            },
            {
              id: "creator",
              name: "工作流创建人"
            }
          ]
        }
      ]
    }
  },
  methods: {
    open(workflow) {
      Promise.all([
        getDepartmentTree({ companyId: this.curUser.companyId }),
        getCompanyUsers({ companyId: this.curUser.companyId }),
        getRoles({ appId: workflow.appId })
      ]).then(([departmentTree, res, appRoles]) => {
        this.rootDepartment = departmentTree[0]
        this.curUsers = res
        this.appRoles = appRoles
        let defaultUserToNotify = []
        if (["START_TYPE_DATA", "START_TYPE_BTN"].includes(workflow.trigger.type))
          defaultUserToNotify = [
            {
              type: "var",
              value: "trigger"
            }
          ]
        else if (workflow.trigger.type !== "START_TYPE_SUB")
          defaultUserToNotify = [
            {
              type: "var",
              value: "creator"
            }
          ]
        this.form = {
          name: ["未命名工作流", "自定义按钮"].includes(workflow.name) ? "" : workflow.name,
          desc: workflow.desc,
          parallel: workflow.parallel,
          userToNotify: this._.isEmpty(workflow.userToNotify)
            ? defaultUserToNotify
            : workflow.userToNotify,
          triggerType: workflow.trigger.type
        }
        this.visible = true
        setTimeout(() => this.$refs.nameInput.focus(), 100)
      })
    },
    submit() {
      if (!this.form.name) {
        this.$message.warning("名称不能为空")
        return
      }
      this.$emit("submit", this.form)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-workflow-info-dialog {
  .row {
    margin-bottom: 15px;
    .title {
      margin-bottom: 10px;
      color: #999;
    }
  }
}
</style>
